import { urlConfig } from "../../config/urlConfig";
import { AccountDetailsContext, AccountModel } from "../../types/AccountModel";
import { FolderRightsModel } from "../../types/FolderRightsModel";
import { getCall, postCall, postCallFormData } from "../httpService";

export const GetClients = async () => {
  try {
    const response = await postCall(urlConfig.GetClients, {});
    return response.data;
  } catch (error) {
    console.log("Error in GetClients to fetching data", error);
    throw error;
  }
};

export const GetClientDetails = async (params: any) => {
  try {
    const urlParams = `{"businessUnitId":${params}}`;
    const response = await getCall(urlConfig.GetClientDetail, urlParams);
    return response;
  } catch (error) {
    console.log("Error in GetClientDetails to fetching data", error);
    throw error;
  }
};

export const GetFolders = async (params: FolderRightsModel) => {
  try {
    const response = await postCall(urlConfig.GetFundFolder, params);
    return response.data;
  } catch (error) {
    console.log("Error in GetFolders to fetching data", error);
    throw error;
  }
};

export const GetAccountMetaDataFields = async (params: AccountModel) => {
  try {
    const response = await postCall(urlConfig.GetAccountMetaData, params);
    return response.data;
  } catch (error) {
    console.log("Error in GetAccountMetaDataFields to fetching data", error);
    throw error;
  }
};

export const GetAccountDetails = async (params: AccountModel) => {
  try {
    const response = await postCall(urlConfig.GetAccountById, params);
    return response.data;
  } catch (error) {
    console.log("Error in GetAccountDetails to fetching data", error);
    throw error;
  }
};

export const GetAccountLogo = async (params: AccountModel) => {
  try {
    const response = await postCall(urlConfig.GetAccountLogo, params);
    return response.data;
  } catch (error) {
    console.log("Error in GetAccountLogo to fetching data", error);
    throw error;
  }
};

export const Add = async (params: AccountDetailsContext) => {
  try {
    const response = await postCallFormData(urlConfig.AddNewAcount, params);
    return response.data;
  } catch (error) {
    console.log("Error in Add to fetching data", error);
    throw error;
  }
};
